import React, { Component } from 'react'
import { Button, Col, Icon, Input, Modal, Row, Select, Spin, Table, Tooltip } from 'antd'
import ArticulosCiclicosRequest from '../../services/ArticulosCiclicos'
import { openNotification } from '../../util/notificaciones'
import { Diario, TotalCiclicos } from '../../constants'
const { confirm } = Modal
const { Option } = Select

export default class FormAgregar extends Component {

    state = {
        busqueda: "",
        filtro: undefined,
        cargando: false,
        cancelModalConfirm: false,
        bloquearBotones: false,
        noConfigurados: [],
        frecuenciaSelected: null,
        selectedRowKeys: [],
        selectedRows: [],
        arrRowsSelected: [],
    }

    existentes = () => { return this.state.frecuenciaSelected === Diario ? this.props.diarios : this.props.semanales }
    restantes = () => { return Math.max(TotalCiclicos - this.existentes(), 0) }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.visible && this.props.visible) {
            this.buscarNoConfigurados()
        }

        if (prevState.filtro !== this.state.filtro) {
            this.buscarNoConfigurados()
        }
    }

    buscarNoConfigurados = () => {
        this.setState(({ cargando: true }), () => {
            ArticulosCiclicosRequest.obtenerNoConfigurados(this.state.filtro)
                .then(response => {
                    const noConfigurados = response.data.results
                    this.setState({ noConfigurados, cargando: false })
                }).catch(err => {
                    this.setState({ cargando: false })
                    openNotification("Ocurrió un error al obtener artículos sin configurar.", "Error", false)
                })
        })
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        let flag = false;
        let rows = [...this.state.arrRowsSelected]
        const restantes = this.restantes()


        if (selectedRows.length > restantes) {
            // rows = rows.concat(selectedRows)
            // let hash = {};
            // rows = rows.filter(o => hash[o.codigo] ? false : hash[o.codigo] = true);
            const recortadas = selectedRows.slice(0, restantes)
            selectedRows = recortadas
            selectedRowKeys = recortadas.map(r => r.id)
        }

        const merged = [...this.state.arrRowsSelected, ...selectedRows]
        const seen = new Set()
        const rowsDedupe = merged.filter(r => {
            if (seen.has(r.id)) return false
            seen.add(r.id)
            return true
        })

        this.setState({ selectedRowKeys, selectedRows, arrRowsSelected: rowsDedupe, editAct: flag }, this.verifyRowsSelected);
    };

    handleCancel = () => {
        this.props.esconderModal(false)
        this.setState({
            cargando: false,
            frecuenciaSelected: null,
            selectedRowKeys: [],
            selectedRows: [],
            arrRowsSelected: [],
            arrArticulos: []
        })
    }

    handleChangeFrecuencia = (value) => {
        this.setState({ frecuenciaSelected: value, selectedRowKeys: [], selectedRows: [] })
    }

    saveArticles = () => {
        let state = { ...this.state }
        state.bloquearBotones = true
        state.cargando = true
        let articles = []

        this.state.arrRowsSelected.forEach(rowSelected => {
            articles.push({
                idArticuloInventario: rowSelected.id,
                frecuencia: this.state.frecuenciaSelected
            })
        });

        this.setState(state, () => {
            ArticulosCiclicosRequest.guardarCiclicos(articles)
                .then(response => {
                    state.bloquearBotones = false
                    state.cargando = false
                    state.frecuenciaSelected = null
                    state.selectedRowKeys = []
                    state.selectedRows = []
                    state.arrRowsSelected = []
                    state.arrArticulos = []

                    this.setState(state, this.props.esconderModal(true, response.data))
                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo,
                    )
                })
                .catch(err => {
                    this.setState({ bloquearBotones: false, cargando: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        "Error",
                    )
                })
        })

    }

    showConfirm = (e) => {
        e.preventDefault()
        confirm({
            title: 'Confirmar',
            content: <div>¿Desea guardar la información?</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-frecuencia-form',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-frecuencia-form',
            },
            onOk: () => {
                this.saveArticles()
            },
        });
    }

    changeText = (value) => {
        let state = { ...this.state };

        if (value.trim() !== state.busqueda.trim()) {
            state.busqueda = value
            state.filtro = value.trim() === "" ? undefined : value.trim()

            this.setState(state)
        }
    }

    render() {
        let columnasArticulosTemp = [
            {
                title: "Código",
                dataIndex: "codigo",
                key: "codigo",
                width: 100,
                show: true
            },
            {
                title: "Nombre",
                dataIndex: "descripcion",
                key: "descripcion",
                show: true,
                width: 150
            },
            {
                title: "UDMA",
                dataIndex: "unidad_almacen",
                key: "unidad_almacen",
                width: 100,
                show: true
            },
            {
                title: "UDMV",
                dataIndex: "unidad_venta",
                key: "unidad_venta",
                width: 100,
                show: true
            },
        ]

        const rowSelection = {
            // selectedRowKeys,
            // onChange: this.onSelectChange,
            // hideDefaultSelections: true,
            // selections: [
            //     {
            //         key: 'all-data',
            //         text: 'Seleccionar todo',
            //         onSelect: () => {
            //             this.setState({
            //                 selectedRowKeys: this.state.arrArticulos.map(item => item.id),
            //                 selectedRows: [...this.state.arrArticulos]
            //             });
            //         },
            //     },
            //     {
            //         key: 'un-select-all',
            //         text: 'Deseleccionar todo',
            //         onSelect: changableRowKeys => {
            //             this.setState({ selectedRowKeys: [], selectedRows: [] });
            //         },
            //     },
            // ],
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: this.onSelectChange,
            onSelect: (record, selected, selectedRows) => {
                const restantes = this.restantes()

                if (selected && selectedRows.length > restantes) {
                    this.onSelectChange(this.state.selectedRowKeys, this.state.selectedRows);
                } else {
                    const keys = selectedRows.map(r => r.id)
                    this.onSelectChange(keys, selectedRows);
                }

            },
            hideDefaultSelections: true,
            onSelectAll: (selected, selectedRows) => {
                const restantes = this.restantes()

                if (!selected) {
                    this.onSelectChange([], [])
                    return
                }
                const permitidas = selectedRows.slice(0, restantes)
                const keys = permitidas.map(r => r.id)
                this.onSelectChange(keys, permitidas)

                if (selectedRows.length > restantes) {
                    openNotification(`Se ha alcanzado el límite de ${TotalCiclicos} artículos cíclicos para la frecuencia seleccionada.`, 'Aviso')
                }
            },
            getCheckboxProps: record => {
                const restantes = this.restantes()
                const yaSeleccionado = this.state.selectedRowKeys.includes(record.id)
                return {
                    disabled: !yaSeleccionado && this.state.selectedRows.length >= restantes
                }
            }
            // selections: [
            //     {
            //         key: 'all-data',
            //         text: 'Seleccionar todo',
            //         onSelect: () => {
            //             this.setState({
            //                 selectedRowKeys: this.state.arrArticulos.map(item => item.id),
            //                 selectedRows: [...this.state.arrArticulos]
            //             });
            //         },
            //     },
            //     {
            //         key: 'un-select-all',
            //         text: 'Deseleccionar todo',
            //         onSelect: changableRowKeys => {
            //             this.setState({ selectedRowKeys: [], selectedRows: [] });
            //         },
            //     },
            // ],
        };

        return (
            <Modal
                title="Agregar artículos cíclicos"
                onCancel={this.handleCancel}
                visible={this.props.visible}
                onOk={this.showConfirm}
                width={"80%"}
                // style={{maxHeight: '800px'}}
                maskClosable={false}
                centered={true}
                footer={
                    [
                        <Button
                            id="boton-regresar-form-frecuencia-productos"
                            className="btnCancelar"
                            key="back"
                            disabled={this.state.bloquearBotones}
                            onClick={this.handleCancel}
                        >
                            Regresar
                        </Button>,
                        <Button
                            id="boton-guardar-form-frecuencia-productos"
                            className={'btnVerCrearGuardar'}
                            key="submit"
                            disabled={this.state.bloquearBotones || this.state.frecuenciaSelected == null || this.state.selectedRows.length == 0}
                            onClick={this.showConfirm}
                            type="primary"> Guardar
                        </Button>
                    ]
                }
            >
                <Row gutter={[24, 16]}>
                    <Col lg={8} md={10} sm={10} xs={10}>
                        <div className="center">Búsqueda:</div>
                        <Input
                            maxLength={50}
                            id="input-buscar-articulos-no-config"
                            placeholder="Buscar por Código / Nombre"
                            value={this.state.busqueda}
                            onChange={e => this.changeText(e.target.value)}
                            prefix={<Icon type='search' />}
                            allowClear
                        />
                    </Col>
                </Row>
                <Row gutter={[24, 16]}>
                    <Col lg={8} md={10} sm={10} xs={10}>
                        <div className="center">Frecuencia:</div>
                        <Tooltip
                            placement="top"
                            title="Seleccione frecuencia">
                            <Select
                                id="select-frecuencia-agregar"
                                showSearch
                                style={{ width: "100%" }}
                                defaultActiveFirstOption={false}
                                notFoundContent='No hay opciones'
                                placeholder="Seleccionar..."
                                optionFilterProp="children"
                                onChange={this.handleChangeFrecuencia}
                                value={this.state.frecuenciaSelected}
                                allowClear
                            >
                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                <Option
                                    key={1}
                                    value={1}
                                    disabled={this.props.diarios === TotalCiclicos}
                                >
                                    Diario
                                </Option>
                                <Option
                                    key={2}
                                    value={2}
                                    disabled={this.props.semanales === TotalCiclicos}
                                >
                                    Semanal
                                </Option>
                            </Select>
                        </Tooltip>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col >
                        <Spin
                            tip='Cargando...'
                            indicator={<Icon type='loading' style={{ fontSize: 24, color: '#e0cbae' }} spin />}
                            spinning={this.state.cargando}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                        >
                            {/* <div style={{ height: '500px' }}> */}
                            <Table
                                style={{width: '100%'}}
                                locale={{ emptyText: 'No se han encontrado resultados.' }}
                                rowKey={articulo => articulo.id}
                                columns={columnasArticulosTemp}
                                dataSource={this.state.noConfigurados}
                                rowSelection={this.state.frecuenciaSelected ? rowSelection : undefined}
                                scroll={{ y: 450 }}
                            />

                            {/* </div> */}

                        </Spin>
                    </Col>
                </Row>
            </Modal>
        )
    }
}
